import React from "react";
import { Link } from "react-router-dom";
import CarouselComponent from "./Carousel";
import './home.css';
import About from "./About";
import Blog from "./Blog";
import Testimonial from "./Testimonial";
import Features from "./Features";
import Team from "./Team";
import Faq from "./Faq";




const Home = () => (
  <>
  <div className="wrapper">
  
    {/* Hero Section */}
    {/* <div className="text-center py-5 bg-light rounded shadow">
      {/* <h1 className="display-4">Welcome to Jarurat.Com</h1> 
      <div className="typeheading">
        <div className="typewriter">
          { <h1 >Welcome to <span className="saara">SAARA</span> Constructions</h1>}
        </div>
      </div>
      <p className="lead">
        Connecting skilled workers with those who need them. Find the right fit for your job or showcase your skills to a wide audience.
      </p>
      <Link to="/workers" className="btn btn-primary btn-lg mx-2">
        Find Workers
      </Link>
      <Link to="/postjob" className="btn btn-outline-secondary btn-lg mx-2">
        Post a Job
      </Link>
    </div> *]*/}

  
    
    
    
    <CarouselComponent/>
    
    <Features/>
    
    
    <About/>
  

  
  <Faq/>

  
  <Blog/>
  <a href="#" class="back-to-top"><i class="fa fa-chevron-up"></i></a>
    

  </div>

  <script src="https://code.jquery.com/jquery-2.1.3.min.js"></script>
      <script src="http://maxcdn.bootstrapcdn.com/bootstrap/3.3.1/js/bootstrap.min.js"></script>

  </>
);

export default Home;
